import styled from "styled-components";

import { Button as MuiButton } from "@material-ui/core";

export const ButtonButtonControl = styled(MuiButton).attrs({ className: "z-30" as string })``;
